import { extractDimensions } from 'feature/sizes/util'
import { useEffect, useMemo, useRef, useState } from 'react'
import { api } from 'store/api'
import { InferenceStore } from 'store/inference/InferenceStore'
import { opt } from 'store/opt'
import { buildSize, DetailedSizesRequest, Size } from 'type/size'

export function useSizes(inference: InferenceStore): Size[] {
  const enabled = opt.sizes
  const company_id = opt.company
  const { collection_id, item_id } = inference
  const [sizes, setSizes] = useState<Size[]>([])
  const v = useRef(0)

  function buildRequests(): DetailedSizesRequest[] {
    if (!enabled) return []

    const dimensions = extractDimensions(inference)
    if (!dimensions) return []

    const { gender, body_type } = dimensions
    const none = !item_id || !collection_id || !gender
    if (none) return []

    const height = opt.measurements.includes('height') ? dimensions.height : undefined
    const shoulders = opt.measurements.includes('shoulders') ? dimensions.shoulders : undefined
    const bust = opt.measurements.includes('bust') ? dimensions.bust : undefined
    const waist = opt.measurements.includes('waist') ? dimensions.waist : undefined
    const hips = opt.measurements.includes('hips') ? dimensions.hips : undefined
    const leg_length = opt.measurements.includes('legLength') ? dimensions.legLength : undefined

    return inference.items.map(it => {
      const item_type = it.dress_shape_type
      const request: DetailedSizesRequest = {
        company_id, collection_id, item_id, body_type, item_type,
        gender, height, shoulders, bust, waist, hips, leg_length,
      }
      return request
    })
  }

  const requests_raw = buildRequests()
  const requests = useMemo(() => requests_raw, [JSON.stringify(requests_raw)])

  useEffect(() => {
    const version = ++v.current
    setSizes([])
    if (!requests.length) return
    const go = async () => {
      const sizes = []
      for (const request of requests) {
        try {
          const { item_type } = request
          const response = await api.getDetailedSizes(request)
          const size = buildSize(item_type, response)
          if (size) sizes.push(size)
        } catch {
        }
      }
      if (v.current === version) setSizes(sizes)
    }
    void go()
  }, [requests])

  return sizes
}
